export var LoginFailedReasonEnum;
(function (LoginFailedReasonEnum) {
    LoginFailedReasonEnum["NoEligibleAccount"] = "NoEligibleAccount";
    LoginFailedReasonEnum["Other"] = "Other";
    LoginFailedReasonEnum["RejectedByCapitalOne"] = "RejectedByCapitalOne";
})(LoginFailedReasonEnum || (LoginFailedReasonEnum = {}));
//# sourceMappingURL=interfaces.js.map